import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.customers')
  .factory('customersAPI', CustomersAPI);

function CustomersAPI(): BringozApi {
  return {
    base: `/customers`,
    infiniteScroll: {
      address: `/customers`,
      cmd: 'GET'
    },
    actions: {
      createCustomer: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      deleteCustomer: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      editCustomer: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      getAddresses: {
        address:'{id}/addresses',
        cmd: 'GET',
        updateable: false
      },
      addAddress: {
        address:'{id}/addresses',
        cmd: 'PUT',
        updateable: true
      },
      updateAddress: {
        address:'{id}/addresses/{addressId}',
        cmd: 'POST',
        updateable: true
      },
      deleteAddress: {
        address:'{id}/addresses/{addressId}',
        cmd: 'DELETE',
        updateable: true
      },
      getDefaultAddress: {
        address:'{id}/addresses/default',
        cmd: 'GET',
        updateable: false
      },
      updateDefaultAddress: {
        address:'{id}/addresses/{addressId}/default',
        cmd: 'POST',
        updateable: true
      },
      export: {
        address: 'export',
        updateable: false,
        cmd: 'POST'
      },
    }
  }
}
